import {useFetch} from "../useFetch";
import {Garage} from "../../types/api/guide/garage.types";
import {garageService} from "../../services/guide/garage-service";

export const useFetchAllGarage = () => {
    const { isLoading, error, data, refetch } = useFetch<Garage[]>(garageService.getAll);

    return { data: data || [], isLoading, error, refetch };
}
